import { mutateApi, queryApi } from "src/utils/api/ApiMethods"

export const getMarinaTaxes = async (marinaSlug) => {
  return queryApi(`/manage/${marinaSlug}/taxes`)
}

export const createMarinaTax = async (marinaSlug, taxData) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/taxes`,
    method: "POST",
    data: taxData,
  })
}

export const deleteMarinaTax = async (marinaSlug, taxId) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/taxes/${taxId}`,
    method: "DELETE",
  })
}
